import { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from './stores/authStore';
import LoginPage from './pages/LoginPage';
import AdminLayout from './components/layout/AdminLayout';
import DashboardPage from './pages/DashboardPage';
import UsersPage from './pages/UsersPage';
import UserDetailPage from './pages/UserDetailPage';
import MessagesPage from './pages/MessagesPage';
import DMPage from './pages/DMPage';
import BoardPage from './pages/BoardPage';
import ConfigPage from './pages/ConfigPage';
import ReportsPage from './pages/ReportsPage';
import PushPage from './pages/PushPage';
import DropsPage from './pages/DropsPage';
import BotManagerPage from './pages/BotManagerPage';

export default function App() {
  const { adminUser, loading, init } = useAuthStore();

  useEffect(() => {
    const unsub = init();
    return unsub;
  }, [init]);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen bg-gray-900">
        <div className="text-white text-lg">Loading...</div>
      </div>
    );
  }

  if (!adminUser) {
    return <LoginPage />;
  }

  return (
    <AdminLayout>
      <Routes>
        <Route path="/" element={<DashboardPage />} />
        <Route path="/users" element={<UsersPage />} />
        <Route path="/users/:uid" element={<UserDetailPage />} />
        <Route path="/messages" element={<MessagesPage />} />
        <Route path="/dm" element={<DMPage />} />
        <Route path="/board" element={<BoardPage />} />
        <Route path="/config" element={<ConfigPage />} />
        <Route path="/reports" element={<ReportsPage />} />
        <Route path="/push" element={<PushPage />} />
        <Route path="/drops" element={<DropsPage />} />
        <Route path="/bot" element={<BotManagerPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AdminLayout>
  );
}
